'use client';

import InlineStyle from '@/components/InlineStyle';
import { formatMonthYear } from '@/lib/formatDate';
import React, { useState } from 'react';
import BookDemoSection from '@/components/BookDemoSection';
import { useTranslation } from "@/hooks/useTranslation";
const ITEMS = [{
  id: 99830,
  slug: 'e3-customer-experience-conference-2025',
  title: "E3 Customer Experience Conference 2025",
  linkedin_url: "https://www.linkedin.com/posts/locobuzz_shapingexperiences-customerexperience-ai-activity-7379068999751532544-gUm6/",
  date: "2025-10-09",
  featured_image: "/wp-content/uploads/decode-customer-signals-29-30Sep.jpg"
}, {
  id: 99829,
  slug: 'big-box-uae-2025',
  title: "Big Box UAE, 2025",
  linkedin_url: "https://www.linkedin.com/posts/locobuzz_cx-customerexperience-marketing-activity-7376597208143413248-ndtT/",
  date: "2025-10-09",
  featured_image: "/wp-content/uploads/futre-of-cx-24sep.jpg"
}, {
  id: 99827,
  slug: '21st-cx-strategy-summit-2025',
  title: "21st CX Strategy Summit 2025",
  linkedin_url: "https://www.linkedin.com/posts/locobuzz_shapingexperiences-cx-customerexperience-activity-7374076889415512064-__j4/",
  date: "2025-10-09",
  featured_image: "/wp-content/uploads/customer-signas-17sep.jpg"
}, {
  id: 99120,
  slug: '12th-edition-dcx-confex-awards',
  title: "12th Edition DCX Confex & Awards",
  linkedin_url: "https://www.linkedin.com/posts/locobuzz_shapingexperiences-customerexperience-cx-activity-7371530762652770304-jiJ-/",
  date: "2025-10-09",
  featured_image: "/wp-content/uploads/future-of-cx-10sep2025.webp"
}, {
  id: 98115,
  slug: 'cx-live-show-malaysia',
  title: "CX Live Show - Malaysia",
  linkedin_url: "https://www.linkedin.com/feed/update/urn:li:activity:7363901257289293825",
  date: "2025-09-09",
  featured_image: "/wp-content/uploads/CXL-KualaLamour.webp"
}, {
  id: 98114,
  slug: 'india-cx-summit-awards-2025',
  title: "India CX Summit & Awards 2025",
  linkedin_url: "https://www.linkedin.com/feed/update/urn:li:activity:7367445016480309248",
  date: "2025-09-09",
  featured_image: "/wp-content/uploads/custoer-signal-delhi-29aug.png"
}, {
  id: 93544,
  slug: 'dcx-bangalore',
  title: "DCX Bangalore",
  linkedin_url: "",
  date: "2025-07-24",
  featured_image: ""
}, {
  id: 92601,
  slug: 'aws-summit',
  title: "AWS Summit",
  linkedin_url: "https://www.linkedin.com/posts/locobuzz_cx-customerexperience-generativeai-activity-7342788240262725632-59SQ",
  date: "2025-06-26",
  featured_image: "/wp-content/uploads/AWS-Summit-Mumbai-2025.webp"
}, {
  id: 92600,
  slug: 'cx-live-show-mena-2025',
  title: "CX Live Show MENA 2025",
  linkedin_url: "https://www.linkedin.com/posts/locobuzz_customerexperience-generativeai-marketing-activity-7329018518761291777-hzsd",
  date: "2025-06-26",
  featured_image: "/wp-content/uploads/CXLive-Mena-2025-Dubai.jpg"
}, {
  id: 89681,
  slug: 'agentforce-world-tour-2025',
  title: "Agentforce World Tour 2025",
  linkedin_url: "https://www.linkedin.com/posts/locobuzz_customerexperience-events-generativeai-activity-7317425684656664577-lsmc",
  date: "2025-04-15",
  featured_image: "/wp-content/uploads/AWT_1_4_2025_final-Copy.webp"
}, {
  id: 88586,
  slug: 'bharat-fintech-summit-2025',
  title: "Bharat Fintech Summit 2025, organised by The Digital Fifth",
  linkedin_url: "https://www.linkedin.com/posts/locobuzz_shapingexperiences-cxm-customerexperience-activity-7292518437019394048-kOHR",
  date: "2025-02-06",
  featured_image: "/wp-content/uploads/BFS25_768x960px-1.webp"
}, {
  id: 81392,
  slug: 'seamless-ksa',
  title: "Seamless KSA",
  linkedin_url: "https://www.linkedin.com/feed/update/urn:li:activity:7248946607524593665",
  date: "2024-10-10",
  featured_image: ""
}, {
  id: 81388,
  slug: 'gitex-global',
  title: "Gitex Global",
  linkedin_url: "https://www.linkedin.com/feed/update/urn:li:activity:7247597984547229696",
  date: "2024-10-10",
  featured_image: ""
}, {
  id: 81268,
  slug: 'martech',
  title: "Martech +",
  linkedin_url: "https://www.linkedin.com/feed/update/urn:li:activity:7244724316460744705",
  date: "2024-10-09",
  featured_image: ""
}, {
  id: 81266,
  slug: 'cx-loyalty-summit',
  title: "CX & Loyalty Summit",
  linkedin_url: "https://www.linkedin.com/feed/update/urn:li:activity:7244386829590839296",
  date: "2024-10-09",
  featured_image: "/wp-content/uploads/Smart-CX-Summit-1.webp"
}, {
  id: 81264,
  slug: 'dreamforce-2024',
  title: "Dreamforce 2024",
  linkedin_url: "https://www.linkedin.com/feed/update/urn:li:activity:7242901657917833216",
  date: "2024-10-09",
  featured_image: ""
}, {
  id: 81262,
  slug: 'cx-strategy-summit',
  title: "CX Strategy Summit",
  linkedin_url: "https://www.linkedin.com/feed/update/urn:li:activity:7240364813179052034",
  date: "2024-10-09",
  featured_image: ""
}, {
  id: 81260,
  slug: 'smart-cx-summit',
  title: "Smart CX Summit",
  linkedin_url: "https://www.linkedin.com/feed/update/urn:li:activity:7235168197237211136",
  date: "2024-10-09",
  featured_image: "/wp-content/uploads/dubai-locobuzz.webp"
}, {
  id: 81250,
  slug: 'big-box-india-2',
  title: "Big Box India",
  linkedin_url: "https://www.linkedin.com/feed/update/urn:li:activity:7234453945945886720",
  date: "2024-10-09",
  featured_image: "/wp-content/uploads/Big-Box-India.webp"
}, {
  id: 81209,
  slug: 'cx-fusion-summit',
  title: "CX Fusion Summit",
  linkedin_url: "https://www.linkedin.com/feed/update/urn:li:activity:7227918186623434752",
  date: "2024-10-08",
  featured_image: "/wp-content/uploads/cx-fusion-summit-min.webp"
}, {
  id: 80509,
  slug: 'seamless-middle-east',
  title: "Seamless Middle East",
  linkedin_url: "",
  date: "2024-01-01",
  featured_image: ""
}];
const LI_BLUE = '#0A66C2';
const FALLBACK_COLORS = ['#0A66C2', '#0E4F96', '#1a3a6e', '#0D4F96', '#164e8a'];
function EventCard({
  item,
  idx
}) {
  const {
    t
  } = useTranslation();
  const hasLink = !!item.linkedin_url;
  const hasImage = !!item.featured_image;
  const dateStr = formatMonthYear(item.date);
  const fallbackBg = `linear-gradient(135deg,${FALLBACK_COLORS[idx % FALLBACK_COLORS.length]},#0D1117)`;
  const Tag = hasLink ? 'a' : 'div';
  const tagProps = hasLink ? {
    href: item.linkedin_url,
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  return <Tag {...tagProps} style={{
    textDecoration: 'none',
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  }}>
      <div style={{
      background: '#fff',
      borderRadius: 16,
      border: '1px solid rgba(79,110,247,0.08)',
      boxShadow: '0 2px 12px rgba(79,110,247,0.04)',
      overflow: 'hidden',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      transition: 'all 0.25s',
      cursor: hasLink ? 'pointer' : 'default'
    }} onMouseEnter={e => {
      if (hasLink) {
        e.currentTarget.style.transform = 'translateY(-5px)';
        e.currentTarget.style.boxShadow = '0 20px 48px rgba(10,102,194,0.14)';
        e.currentTarget.style.borderColor = 'rgba(10,102,194,0.2)';
      }
    }} onMouseLeave={e => {
      e.currentTarget.style.transform = 'none';
      e.currentTarget.style.boxShadow = '0 2px 12px rgba(79,110,247,0.04)';
      e.currentTarget.style.borderColor = 'rgba(79,110,247,0.08)';
    }}>

        {/* Image / fallback */}
        <div style={{
        position: 'relative',
        overflow: 'hidden',
        flexShrink: 0,
        maxHeight: 500
      }}>
          {hasImage ? <img src={item.featured_image} alt={item.title} loading="lazy" decoding="async" style={{
          width: '100%',
          height: 'auto',
          display: 'block',
          transition: 'transform 0.4s',
          maxHeight: 500,
          objectFit: 'cover'
        }} onMouseEnter={e => {
          e.currentTarget.style.transform = 'scale(1.04)';
        }} onMouseLeave={e => {
          e.currentTarget.style.transform = 'scale(1)';
        }} /> : <div style={{
          width: '100%',
          minHeight: 180,
          background: fallbackBg,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24
        }}>
              <span style={{
            fontSize: 13,
            fontWeight: 700,
            color: 'rgba(255,255,255,0.8)',
            textAlign: 'center',
            fontFamily: "'Inter Tight',sans-serif",
            lineHeight: 1.4
          }}>{item.title}</span>
            </div>}

          {/* LinkedIn badge top-right */}
          <div style={{
          position: 'absolute',
          top: 10,
          right: 10
        }}>
            {hasLink ? <div style={{
            width: 30,
            height: 30,
            borderRadius: 7,
            background: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)'
          }}>
                <svg width="17" height="17" viewBox="0 0 24 24" fill={LI_BLUE}><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>
              </div> : <div style={{
            background: 'rgba(0,0,0,0.5)',
            backdropFilter: 'blur(8px)',
            color: '#fff',
            fontSize: 9,
            fontWeight: 700,
            padding: '3px 8px',
            borderRadius: 100,
            fontFamily: "'Inter Tight',sans-serif"
          }}>{t("btn.coming_soon")}</div>}
          </div>

          {/* Date badge bottom-left */}
          <div style={{
          position: 'absolute',
          bottom: 10,
          left: 10,
          background: 'rgba(0,0,0,0.6)',
          backdropFilter: 'blur(8px)',
          color: '#fff',
          fontSize: 10,
          fontWeight: 700,
          padding: '3px 10px',
          borderRadius: 100,
          fontFamily: "'Inter Tight',sans-serif"
        }}>
            {dateStr}
          </div>
        </div>

        {/* Content */}
        <div style={{
        padding: '16px 18px 18px',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        gap: 10
      }}>
          <h3 style={{
          fontFamily: "'Inter Tight',sans-serif",
          fontWeight: 600,
          fontSize: 14,
          color: '#0D1117',
          lineHeight: 1.45,
          margin: 0,
          flex: 1
        }}>
            {item.title}
          </h3>
          <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          paddingTop: 10,
          borderTop: '1px solid #F0F4FF'
        }}>
            <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: 6
          }}>
              <div style={{
              width: 20,
              height: 20,
              borderRadius: 5,
              background: LI_BLUE,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
                <svg width="11" height="11" viewBox="0 0 24 24" fill="#fff"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>
              </div>
              <span style={{
              fontSize: 11,
              fontWeight: 600,
              color: '#6B7280',
              fontFamily: "'Inter Tight',sans-serif"
            }}>{t("resources_events.locobuzz")}</span>
            </div>
            {hasLink ? <span style={{
            fontSize: 12,
            fontWeight: 700,
            color: LI_BLUE,
            fontFamily: "'Inter Tight',sans-serif",
            display: 'flex',
            alignItems: 'center',
            gap: 4
          }}>
                {t("resources_events.view_post")}
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke={LI_BLUE} strokeWidth="2.5" strokeLinecap="round"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6M15 3h6v6M10 14L21 3" /></svg>
              </span> : <span style={{
            fontSize: 11,
            color: '#9CA3AF',
            fontFamily: "'Inter Tight',sans-serif"
          }}>{t("resources_events.no_link_yet")}</span>}
          </div>
        </div>
      </div>
    </Tag>;
}
const PAGE_SIZE = 9;
export default function EventsPage() {
  const {
    t
  } = useTranslation();
  const [page, setPage] = React.useState(0);
  const totalPages = Math.ceil(ITEMS.length / PAGE_SIZE);
  const shown = ITEMS.slice(page * PAGE_SIZE, page * PAGE_SIZE + PAGE_SIZE);
  return <>
      <section style={{
      background: 'linear-gradient(135deg,#EEF0FF,#F0EBFF,#EBF0FF)',
      padding: 'var(--hero-pad)',
      textAlign: 'center'
    }}>
        <div className="container">
          <span style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 7,
          padding: '5px 14px',
          borderRadius: 100,
          border: `1px solid rgba(10,102,194,0.3)`,
          background: 'rgba(10,102,194,0.07)',
          fontSize: 12,
          fontWeight: 500,
          color: LI_BLUE,
          fontFamily: "'Inter Tight',sans-serif",
          marginBottom: 16
        }}>
            <span style={{
            width: 6,
            height: 6,
            borderRadius: '50%',
            background: LI_BLUE,
            flexShrink: 0
          }} />{t("res.events")}
          </span>
          <h1 style={{
          fontFamily: "'Inter Tight',sans-serif",
          fontWeight: 500,
          fontSize: 'clamp(28px,4vw,48px)',
          color: '#0D1117',
          lineHeight: 1.1,
          letterSpacing: '-0.03em',
          maxWidth: 600,
          margin: '0 auto 20px'
        }}>
            {t("resources_events.locobuzz_at_events_around_the_world")}
          </h1>
          <p style={{
          fontSize: 17,
          color: '#4B5563',
          maxWidth: 480,
          margin: '0 auto 28px',
          lineHeight: 1.7,
          fontFamily: "'Inter Tight',sans-serif"
        }}>
            {t("resources_events.from_gitex_to_dreamforce_see_where")}
          </p>
          <a href="https://www.linkedin.com/company/locobuzz/" target="_blank" rel="noopener noreferrer" style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '11px 24px',
          borderRadius: 100,
          background: LI_BLUE,
          color: '#fff',
          fontSize: 14,
          fontWeight: 700,
          textDecoration: 'none',
          fontFamily: "'Inter Tight',sans-serif"
        }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="#fff"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" /></svg>
            {t("resources_events.follow_us_on_linkedin")}
          </a>
        </div>
      </section>

      <section style={{
      background: '#F8FAFF',
      padding: '56px 0'
    }}>
        <div className="container">
          <p style={{
          fontSize: 13,
          color: '#9CA3AF',
          marginBottom: 24,
          fontFamily: "'Inter Tight',sans-serif"
        }}>
            {ITEMS.length} {t("res.events")}
          </p>
          <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(3,1fr)',
          gap: 24
        }} className="lb-grid-3 events-grid">
            {shown.map((item, idx) => <EventCard key={item.id} item={item} idx={page * PAGE_SIZE + idx} />)}
          </div>

          {/* Pagination */}
          {totalPages > 1 && <div style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 8,
          marginTop: 48
        }}>
              <button onClick={() => {
            setPage(p => Math.max(0, p - 1));
            window.scrollTo({
              top: 400,
              behavior: 'smooth'
            });
          }} disabled={page === 0} style={{
            padding: '10px 22px',
            borderRadius: 100,
            border: '1.5px solid rgba(79,110,247,0.2)',
            background: page === 0 ? '#F8FAFF' : '#fff',
            color: page === 0 ? '#C4C9D4' : '#4F6EF7',
            fontSize: 13,
            fontWeight: 700,
            cursor: page === 0 ? 'not-allowed' : 'pointer',
            fontFamily: "'Inter Tight',sans-serif",
            transition: 'all 0.2s'
          }}>
                {t("resources_events.previous")}
              </button>
              {Array.from({
            length: totalPages
          }).map((_, i) => <button key={i} onClick={() => {
            setPage(i);
            window.scrollTo({
              top: 400,
              behavior: 'smooth'
            });
          }} style={{
            width: 38,
            height: 38,
            borderRadius: '50%',
            border: `1.5px solid ${i === page ? '#4F6EF7' : 'rgba(79,110,247,0.15)'}`,
            background: i === page ? 'linear-gradient(135deg,#4F6EF7,#6C47F5)' : '#fff',
            color: i === page ? '#fff' : '#6B7280',
            fontSize: 14,
            fontWeight: 700,
            cursor: 'pointer',
            fontFamily: "'Inter Tight',sans-serif",
            transition: 'all 0.2s'
          }}>
                  {i + 1}
                </button>)}
              <button onClick={() => {
            setPage(p => Math.min(totalPages - 1, p + 1));
            window.scrollTo({
              top: 400,
              behavior: 'smooth'
            });
          }} disabled={page === totalPages - 1} style={{
            padding: '10px 22px',
            borderRadius: 100,
            border: '1.5px solid rgba(79,110,247,0.2)',
            background: page === totalPages - 1 ? '#F8FAFF' : '#fff',
            color: page === totalPages - 1 ? '#C4C9D4' : '#4F6EF7',
            fontSize: 13,
            fontWeight: 700,
            cursor: page === totalPages - 1 ? 'not-allowed' : 'pointer',
            fontFamily: "'Inter Tight',sans-serif",
            transition: 'all 0.2s'
          }}>
                {t("resources_events.next")}
              </button>
            </div>}

        </div>
      </section>

      <BookDemoSection />

      <InlineStyle css={`
        @media (max-width: 960px) {
          .events-grid { grid-template-columns: repeat(2, 1fr) !important; }
        }
        @media (max-width: 720px) {
          .events-grid { grid-template-columns: 1fr !important; gap: 18px !important; }
        }
      `} />
    </>;
}